"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var base_1 = require("@bhtp-client-api/base");
var ApiEditTraveler = (function (_super) {
    __extends(ApiEditTraveler, _super);
    function ApiEditTraveler() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editCorrelationId = null;
        return _this;
    }
    return ApiEditTraveler;
}(base_1.ApiTraveler));
exports.ApiEditTraveler = ApiEditTraveler;
//# sourceMappingURL=D:/a/1/s/edit/src/models/edit-traveler.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/edit/src/models/edit-traveler.model.js